import React, { Component } from "react";
import { NavLink } from "react-router-dom";
import axios from "../../axios";
import Alert from "react-s-alert";
import CustomModal from "../../components/CustomModal";
import qs from "qs";
import Paging from "../../components/Paging";

class Category extends Component {
	constructor() {
		super();

		this.state = {
			dataCat: [],
			cat_id: 0,
			cat_name: "",
			pageCount: 0,
			currentPage: 0,
			isLoading: false,
			isButtonLoading: false,
			isModalShow: false,
			editCat: false
		};

		this.toggleModal = this.toggleModal.bind(this);
		this.handleSubmitDeleteButton = this.handleSubmitDeleteButton.bind(this);
	}

	toggleModal() {
		this.setState({ isModalShow: !this.state.isModalShow });
	}

	handleChange(event) {
		const target = event.target;
		const value = target.type === "checkbox" ? target.checked : target.value;
		const name = target.name;

		this.setState({
			[name]: value
		});
	}

	onEditChange(id, name) {
		this.setState({
			cat_id: id,
			cat_name: name,
			editCat: true
		});
	}

	clearEdit() {
		this.setState({
			cat_id: 0,
			cat_name: "",
			editCat: false
		});
	}

	handleSubmitDeleteButton() {
		this.toggleModal();

		axios({
			method: "get",
			url: "/kategori/delete/" + this.state.cat_id
		})
			.then(response => {
				Alert.success("Data berhasil dihapus");
				this.loadData();

				return;
			})
			.catch(error => {
				console.log(error);
				this.setState({ isLoading: false });
				Alert.error("Gagal terhubung ke server!");
			});
	}

	handlePageClick(data) {
		let selected = data.selected; // zero based index

		this.setState({ currentPage: selected }, () => {
			this.loadData();
		});
	}

	handleSubmit() {
		let formData = new FormData();

		const config = {
			headers: { "content-type": "multipart/form-data" }
		};

		formData.append("cat_id", this.state.cat_id);
		formData.append("cat_name", this.state.cat_name);

		const url = this.state.editCat ? "kategori/edit" : "kategori/add";

		this.setState({ isButtonLoading: true });

		axios
			.post(url, formData, config)
			.then(response => {
				const result = response.data;

				if (result.success) {
					Alert.success(result.message);
					this.loadData();
				} else {
					if (Array.isArray(result.message)) {
						result.message.map(item => {
							Alert.error(item);

							return true;
						});
					} else {
						Alert.error(result.message);
					}

					this.setState({ isButtonLoading: false });
				}
			})
			.catch(error => {
				console.log("ERROR", error);
				Alert.error("Gagal terhubung ke server!");
				this.setState({ isButtonLoading: false });
			});
	}

	loadData() {
		this.setState({ isLoading: true });

		const params = qs.stringify({
			page: this.state.currentPage + 1
		});

		axios({
			method: "post",
			url: "/kategori?" + params
		})
			.then(response => {
				const result = response.data;

				if (result.success === true) {
					this.setState({
						dataCat: result.data.data,
						pageCount: result.data.last_page,
						isLoading: false,
						isButtonLoading: false,
						isModalShow: false,
						cat_id: 0,
						cat_name: "",
						editCat: false
					});
				} else {
					Alert.error(result.message);
					this.setState({ isLoading: false });
				}
			})
			.catch(error => {
				console.log(error);
				this.setState({ isLoading: false });
				Alert.error("Gagal terhubung ke server!");
			});
	}

	componentDidMount() {
		this.loadData();
	}

	render() {
		return (
			<div className="col-sm-12">
				<CustomModal
					isShow={this.state.isModalShow}
					toggleModal={this.toggleModal}
					handleSubmit={this.handleSubmitDeleteButton}
					modalHeaderText="Hapus Data"
					modalBodyText="Anda yakin ingin menghapus data ini?"
					modalSubmitText="Ya"
				/>

				<div className="card">
					<div className="card-block">
						<NavLink to={`/news`} className="btn btn-info">
							<i className="fa fa-chevron-left" /> Kembali
						</NavLink>
					</div>
				</div>

				<div className="row">
					<div className="col-md-7">
						<div className="card">
							<div className="card-header">Kategori Event</div>
							<div className="card-block">
								{this.state.isLoading ? (
									"Memuat Data..."
								) : this.state.dataCat.length === 0 ? (
									"Data Kosong..."
								) : (
									<div>
										<table className="table table-striped table-bordered animated fadeIn">
											<thead>
												<tr>
													<th>Nama Kategori</th>
													<th width="140">Opsi</th>
												</tr>
											</thead>
											<tbody>
												{this.state.dataCat.map(item => {
													return (
														<tr key={item.cat_id}>
															<td>{item.cat_name}</td>
															<td>
																<button
																	type="button"
																	className="btn btn-secondary btn-sm"
																	onClick={this.onEditChange.bind(
																		this,
																		item.cat_id,
																		item.cat_name
																	)}
																>
																	Edit
																</button>
																&nbsp;
																<button
																	type="button"
																	className="btn btn-danger btn-sm"
																	onClick={() => {
																		this.toggleModal();
																		this.setState({ cat_id: item.cat_id });
																	}}
																>
																	Hapus
																</button>
															</td>
														</tr>
													);
												})}
											</tbody>
										</table>

										<Paging
											handlePageClick={this.handlePageClick.bind(this)}
											pageCount={this.state.pageCount}
											currentPage={this.state.currentPage}
										/>
									</div>
								)}
							</div>
						</div>
					</div>
					<div className="col-md-5">
						<div className="card">
							<div className="card-header">
								{this.state.editCat ? "Edit" : "Tambah"} Kategori
							</div>
							<div className="card-block">
								<div className="form-horizontal animated fadeIn">
									<div className="form-group row">
										<div className="col-md-12">
											<input
												name="cat_id"
												type="hidden"
												className="form-control"
												value={this.state.cat_id}
												onChange={this.handleChange.bind(this)}
											/>

											<input
												name="cat_name"
												type="text"
												className="form-control"
												placeholder="Nama Kategori"
												value={this.state.cat_name}
												onChange={this.handleChange.bind(this)}
											/>
										</div>
									</div>
								</div>
							</div>
							<div className="card-footer" style={{ "text-align": "right" }}>
								{this.state.editCat && (
									<button
										type="button"
										className="btn btn-md btn-danger"
										disabled={this.state.isButtonLoading && "disabled"}
										onClick={this.clearEdit.bind(this)}
										style={{ "margin-right": "3px" }}
									>
										Batal
									</button>
								)}
								<button
									type="button"
									className="btn btn-md btn-primary"
									disabled={this.state.isButtonLoading && "disabled"}
									onClick={this.handleSubmit.bind(this)}
								>
									{this.state.isButtonLoading ? "Loading" : "Simpan"}
								</button>
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

export default Category;



// WEBPACK FOOTER //
// ./src/views/Soal/Category.js